/**
 * French Number to Words (Handling 70, 80, 90 rules)
 */
const units = ['zéro', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
const tens = ['', 'dix', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante-dix', 'quatre-vingts', 'quatre-vingt-dix'];

function numberToFrench(n) {
  if (n < 10) return units[n];
  if (n < 20) {
    const teens = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
    return teens[n - 10];
  }
  if (n < 70) {
    const t = Math.floor(n / 10);
    const u = n % 10;
    if (u === 0) return tens[t];
    if (u === 1) return tens[t] + ' et un';
    return tens[t] + '-' + units[u];
  }
  if (n < 80) {
    const u = n % 10;
    if (u === 1) return 'soixante et onze';
    return 'soixante-' + numberToFrench(10 + u);
  }
  if (n < 90) {
    const u = n % 10;
    if (u === 0) return 'quatre-vingts';
    return 'quatre-vingt-' + units[u];
  }
  if (n < 100) {
    const u = n % 10;
    return 'quatre-vingt-' + numberToFrench(10 + u);
  }
  if (n < 1000) {
    const h = Math.floor(n / 100);
    const r = n % 100;
    let res = (h === 1) ? 'cent' : units[h] + ' cents';
    if (r > 0) res = (h === 1 ? 'cent' : units[h] + ' cent') + ' ' + numberToFrench(r);
    return res;
  }
  if (n < 1000000) {
    const k = Math.floor(n / 1000);
    const r = n % 1000;
    let res = (k === 1) ? 'mille' : numberToFrench(k) + ' mille';
    if (r > 0) res += ' ' + numberToFrench(r);
    return res;
  }
  return n.toString();
}

export const convertToFrench = (num) => {
  const isNegative = num < 0;
  num = Math.abs(num);
  const intPart = Math.floor(num);
  const decPart = Math.round((num - intPart) * 100);
  
  let res = (isNegative ? 'moins ' : '') + numberToFrench(intPart);
  if (decPart > 0) res += ' virgule ' + numberToFrench(decPart);
  return res;
};